import { useState, useEffect, useRef } from "react";
import SetUpBox from "./components/SetUpBox";
import GameplayBox from "./components/GameplayBox";
import ResultBox from "./components/ResultBox";
import TutorialPage from "./components/TutorialPage";
import AudioControls from "../../GameComponents/AudioControls";
import { useLocation } from "react-router-dom";
import "./style/JumpRopePage.css";
import { useVocabUnitData } from "../../../../database";
import { onAuthStateChanged } from "firebase/auth";
import { FIREBASE_AUTH } from "../../../../FirebaseConfig";
import bgm from "./resources/jump_rope_bgm.mp3";

export default function JumpRopePage() {
    const [pageState, setPageState] = useState("setup"); // 'setup', 'gameplay', 'results', 'tutorial'
    const [gamestate, setGameState] = useState({
        difficulty: "easy",
        unit_words: [],
        words: [],
        currentWordIndex: 0,
        lives: 3,
        correctAnswers: 0,
        wrongAnswers: []
    });
    const location = useLocation();
    const { unit, category } = location.state;

    const [user, setUser] = useState(null);
    const audioRef = useRef(null);
    const [volume, setVolume] = useState(0.5);
    const [isMuted, setIsMuted] = useState(false);

    // Play background music when entering gameplay
    useEffect(() => {
        if (pageState === "gameplay" && audioRef.current) {
            audioRef.current.volume = volume;
            audioRef.current.play().catch((err) => console.log("Audio autoplay blocked:", err));
        } else if (pageState !== "gameplay" && audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    }, [pageState, volume]);

    // Update volume when volume state changes
    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = isMuted ? 0 : volume;
        }
    }, [volume, isMuted]);

    useEffect(() => {
        onAuthStateChanged(FIREBASE_AUTH, (user) => {
            setUser(user);
        });
    });
    
    const { data: vocabData, loading, error } = useVocabUnitData(unit.unit, unit.textbook); // initial api call
    useEffect(() => {
        if (!loading) {
            setGameState((prev) => ({
                ...prev,
                words: vocabData,
                unit_words: vocabData
            }));
        }
    }, [loading, vocabData]);


    useEffect(() => {
        if (pageState === "gameplay") {
            setGameState((prev) => ({
                ...prev,
                words: [...prev.words].sort(() => Math.random() - 0.5),
                currentWordIndex: 0,
                lives: 3,
                correctAnswers: 0,
                wrongAnswers: []
            }));
        } else if (pageState === "setup") {
            setGameState((prev) => ({
                ...prev,
                words: vocabData
            }));
        }
    }, [pageState,vocabData]);

    if (loading) {
        return (
            <div className="loading-screen">
                <h2>Loading vocabulary...</h2>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-screen">
                <h2>Error loading vocabulary: {error}</h2>
            </div>
        );
    }
    
    // Determine which component to render based on pageState
    const renderPageContent = () => {
        if (pageState === "setup") {
            return <SetUpBox unit={unit} category={category} setPageState={setPageState} gamestate={gamestate} setGameState={setGameState} />;
        }
        if (pageState === "tutorial") {
            return <TutorialPage setPageState={setPageState} />;
        }
        if (pageState === "gameplay" && gamestate.words.length > 0) {
            return <GameplayBox unit={unit} user={user} setPageState={setPageState} gamestate={gamestate} setGameState={setGameState} />;
        }
        if (pageState === "results") {
            return <ResultBox setPageState={setPageState} gamestate={gamestate} setGameState={setGameState} />;
        }
    };
    
    return (
        <div className="jumprope-page">
            <audio 
                ref={audioRef} 
                src={bgm} 
                loop 
            />
            <AudioControls 
                volume={volume} 
                setVolume={setVolume} 
                isMuted={isMuted} 
                setIsMuted={setIsMuted} 
            />
            {renderPageContent()}
        </div>
    );
}



